import { Trans, useTranslation } from "next-i18next"
import { useEffect, useState } from "react"
import { useRouter } from "next/router"

import SignInForm from "../components/local/SignIn/Form"
import SignAdvantagesList from "../components/local/SignIn/AdvantagesList"

import Header from "../components/Header"
import Footer from "../components/local/Footer"
import { useSnackbar } from "../hooks/useSnackbar"
import Styles from "./sign-in.module.scss"

export { getServerSideProps } from "../utils/getServerSideProps"

function SignIn() {
  const { t } = useTranslation("common")
  const router = useRouter()
  const { openSnackbar } = useSnackbar()
  const [showLoginWarning, setLoginWarning] = useState(false)

  useEffect(() => {
    const { redirect } = router.query

    const redirectUrl = localStorage.getItem("redirectUrl")

    if (redirect && typeof window !== "undefined" && !showLoginWarning) {
      openSnackbar(t("SIGNIN_LOGIN_TO_CONTINUE"))

      setLoginWarning(true)
    }

    if (redirect && redirect !== redirectUrl) {
      localStorage.setItem("redirectUrl", redirect)
    }
  }, [router.query, openSnackbar, showLoginWarning, t])

  const advantages = (
    <div className="flex flex-col justify-center flex-2">
      <SignAdvantagesList />
    </div>
  )

  const signInForm = (
    <div>
      <div className="font-sans tracking-wider font-medium text-lg">
        {t("SIGNIN_SIGN_IN_NOW")}
      </div>

      <SignInForm />
    </div>
  )

  return (
    <>
      <Header />
      <div className={Styles.Wrapper}>
        <h1 className="text-2xl md:text-3xl font-bold font-sans tracking-wider  text-center md:text-left">
          <Trans
            i18nKey="SIGNIN_WELCOME_BACK"
            values={{
              appName: t("APP_NAME"),
            }}
            components={{
              appName: (
                <span style={{ color: "#0019FF" }}>{t("APP_NAME")}</span>
              ),
            }}
          />
        </h1>
        <div className={Styles.WrapperAdvSign}>
          {advantages}
          {signInForm}
        </div>
      </div>

      <Footer />
    </>
  )
}

export default SignIn
